import PropTypes from 'prop-types'

const parseValue = value => {
  if (typeof value === 'string') {
    return value
  }

  if (Array.isArray(value)) {
    return value?.[0]
  }

  return ''
}

const Text = ({ value, className = '' }) => {
  const parsedValue = parseValue(value)

  if (!parsedValue) {
    return null
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: parsedValue }} />
}

// Same shape, no markup sink: a range label is a value, not authored copy, so it renders as a
// text child and any tags in it stay inert.
export const PlainText = ({ value, className = '' }) => {
  const parsedValue = parseValue(value)

  if (!parsedValue) {
    return null
  }

  return <div className={className}>{parsedValue}</div>
}

Text.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

PlainText.propTypes = Text.propTypes

export default Text
